import React, { useState } from "react";
import { api } from "../lib/api";
import { Check, Send } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/contact", form);
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Failed to send");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page" className="bg-ink text-white pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-mono text-xs uppercase tracking-[0.4em] text-adrenaline">Hit Us Up</div>
        <h1 className="text-display text-6xl md:text-8xl uppercase leading-none mt-3">Contact</h1>
        <p className="text-zinc-400 mt-6 max-w-xl">Wholesale, custom fitments, sponsorship, press, or just a question. We answer everything.</p>
        <div className="section-divider mt-12" />
        {done ? (
          <div data-testid="contact-success" className="mt-12 flex items-center gap-3">
            <span className="h-10 w-10 grid place-items-center border border-adrenaline text-adrenaline"><Check size={20} /></span>
            <div>
              <div className="text-heading uppercase tracking-wider">Message received.</div>
              <div className="text-zinc-500 text-mono text-xs uppercase tracking-widest">We'll respond within 24–48hrs.</div>
            </div>
          </div>
        ) : (
          <form data-testid="contact-form" onSubmit={submit} className="mt-12 grid md:grid-cols-2 gap-x-8 gap-y-8">
            <input data-testid="contact-name" required placeholder="Your Name" className="input-line md:col-span-1" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input data-testid="contact-email" required type="email" placeholder="Email" className="input-line md:col-span-1" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input data-testid="contact-subject" placeholder="Subject" className="input-line md:col-span-2" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
            <textarea data-testid="contact-message" required placeholder="Message" rows={5} className="input-line md:col-span-2 resize-none" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
            {error && <div className="md:col-span-2 text-adrenaline text-mono text-xs uppercase">{error}</div>}
            <button data-testid="contact-submit" disabled={loading} className="md:col-span-2 mt-4 px-8 py-4 bg-adrenaline text-white text-heading uppercase tracking-[0.2em] text-sm hover:bg-red-600 flex items-center gap-3 justify-center w-fit btn-glow">
              {loading ? "Sending…" : <>Send Message <Send size={14} /></>}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
